const fullToHalf = new Map<string, string>();

for (let code = 0xff61; code <= 0xff9f; code++) {
  const half = String.fromCharCode(code);
  fullToHalf.set(half.normalize('NFKC'), half);

  for (const mark of ['\uff9e', '\uff9f']) {
    const marked = half + mark;
    const full = marked.normalize('NFKC');

    if ([...full].length === 1) {
      fullToHalf.set(full, marked);
    }
  }
}

export function normalizeFrame(value: string | null | undefined): string {
  const decoded = (value ?? '').replace(
    /&#(?:x([0-9a-f]+)|([0-9]+));/gi,
    (entity, hex: string, decimal: string) => {
      const code = parseInt(hex || decimal, hex ? 16 : 10);
      return code > 0 && code <= 0x10ffff && (code < 0xd800 || code > 0xdfff)
        ? String.fromCodePoint(code)
        : entity;
    },
  );

  return [...decoded.normalize('NFC')].map((char) => fullToHalf.get(char) ?? char).join('');
}

export function frameKey(value: string | null | undefined): string {
  return normalizeFrame(value).normalize('NFKC');
}

export function frameVariants(value: string): string[] {
  const half = normalizeFrame(value);
  const full = half.normalize('NFKC');
  const encodedHalf = half.replace(/[\uff61-\uff9f]/g, (char) => `&#${char.charCodeAt(0)};`);
  const encodedFull = full.replace(/[\u30a0-\u30ff]/g, (char) => `&#${char.charCodeAt(0)};`);

  return [...new Set([value, half, full, encodedHalf, encodedFull])];
}
